<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <create-reportfaculty></create-reportfaculty>
    </div>
  </div>
</template>

<script>
import CreateReportfaculty from "../../components/CreateReportfaculty.vue";
// import YimoVueEditor from "yimo-vue-editor/src/Editor";

export default {
  components: {
    CreateReportfaculty,
    // hexToRgba,
    // CustomTooltips,
  },
  // extends: Line,

  name: "Reportfaculty",
  data() {
    return {
      items: [],
      categorey: []
    };
  },
  methods: {},
  mounted() {
  },
  created() {
  }
};
</script>
<style></style>
